<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>

<div class="container-fluid pt-5">
    <div class="d-flex justify-content-end"> 
        <div class="col-xl-9 col-lg-9 col-md-8 p-2">
        
            <div class="row">            
                <!-- Top Slideshow -->
                <div class="col-12"> 
                    <div class="card my-3">
                        <div id="carouselExampleControls2" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <ng-container *ngFor="let doc of pictureCol | async; index as i; first as isFirst; last as isLast">        
                            <div [ngClass]="isFirst ? 'carousel-item active' : 'carousel-item' ">
                                <div class="">
                                <img [src]="doc.pictureUrl" class="card-img-top slider-img">                      
                                </div>
                            </div>  
                            </ng-container>       
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleControls2" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleControls2" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>   
                </div>

                <!-- left column - Product Details -->        
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="card mx-auto my-3 shadow-lg">                                           
                        <div class="card-body">
                            <h2>Product Details</h2>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item font-weight-bold">{{(paintingDoc | async)?.name}}</li>
                                <li class="list-group-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cash" viewBox="0 0 16 16">
                                        <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                                        <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z"/>
                                    </svg>
                                    {{(paintingDoc | async)?.price | currency: 'K'}}
                                </li>
                                <li class="list-group-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-collection" viewBox="0 0 16 16">
                                        <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z"/>
                                    </svg>
                                    {{(paintingDoc | async)?.category}}
                                </li>                                
                                <li class="list-group-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-check" viewBox="0 0 16 16">
                                        <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                                    </svg>
                                    {{(paintingDoc | async)?.dateCreated | date}}
                                </li>
                                <li class="list-group-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                      </svg>
                                    {{(paintingDoc | async)?.description}}
                                </li>
                            </ul>                  
                        </div> 
                    </div> 
                    <div class="card mx-auto my-3 shadow-lg card-sticky">                                           
                        <div class="card-body">
                            <h2>Seller Details</h2> 
                            <ul class="list-group list-group-flush">
                                          
                                                  
                                  
                                <li class="list-group-item font-weight-bold">
                                    <div class="media">                        
                                        <img [src]="(paintingDoc | async)?.ownerProfilePictureUrl" class="mr-3 align-self-center rounded-circle image" alt="...">
                                        <div class="media-body align-self-center">
                                          {{(paintingDoc | async)?.ownerName}}
                                        </div>
                                    </div> 
                                </li>
                                <li class="list-group-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                                    </svg>
                                    +(675)-{{(paintingDoc | async)?.ownerPhone}}
                                </li>
                                <li class="list-group-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                                      </svg>
                                    {{(paintingDoc | async)?.ownerLocation}}
                                </li>

                            </ul>                  
                        </div> 
                    </div>                              
                </div>
                
                <!-- right column - Product List -->
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="card mx-auto my-3 shadow-lg">                                           
                        <div class="card-body">
                        <h2>More Products</h2>                               
                    </div>
                </div> 
                                    
                <div class="card my-3"  *ngFor="let paintingDoc of paintingCol | async">
                    <img [src]="paintingDoc.pictureUrl" class="card-img-top">
                    <div class="card-body">
                        <small class="text-muted font-italic">{{paintingDoc.dateCreated | date}}</small>
                        <p class="font-weight-bold">{{paintingDoc.name}}</p>
                        <p>{{paintingDoc.price | currency:'K'}}</p>
                        <a (click)="routePaintingDetailPage(paintingDoc.id)" routerLink="" class="btn btn-dark text-white">View Details...</a>
                    </div>
                </div>   
            </div>
        
        </div>
    </div>
</div>
